import { createContext } from 'react';
import { RestaurantNotificationEventType, ICreateScheduledPush } from 'types';

export type TTypeOfCreateScheduleModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error';

export interface ICreateScheduleState {
	pushType: RestaurantNotificationEventType | null;
	schedule: string;
	dataForSubmit: ICreateScheduledPush | null;
	typeOfModalWindow: TTypeOfCreateScheduleModalWindow;
}

export const createScheduleInitialState: ICreateScheduleState = {
	pushType: null,
	schedule: '',
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface ICreateScheduleContext extends ICreateScheduleState {
	setPushType(value: RestaurantNotificationEventType | null): void;
	changeSchedule(value: string): void;
	setDataForSubmit(value: ICreateScheduledPush | null): void;
	changeTypeOfModalWindow(value: TTypeOfCreateScheduleModalWindow): void;
	resetFields(): void;
}

export const CreateScheduleContext = createContext<ICreateScheduleContext>({
	setPushType: () => undefined,
	changeSchedule: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...createScheduleInitialState,
});
